import Button from "../../../../../components/button";
import { Plus, SearchLoop } from "../../../../../assets/icons";
import useSlideOver from "../../../../../components/SlideOver/useSlideOver";
import UseContext from "../../../../../hooks/useContext";
import StyledInput from "../../../../../components/styledInput/StyledInput";
import { QUALIFICATION_SEARCH_OPTIONS } from "../../qualification";

const HeaderQualification = ({ search, setSearch, optionSearch, setOptionSearch, mobileOnly = false }) => {
    const { setObjID } = UseContext();
    const { toggleSlideOver } = useSlideOver();

    const addQualification = () => {
        setObjID('');
        toggleSlideOver('qualification');
    };

    // Sur mobile, afficher uniquement le bouton Ajouter
    if (mobileOnly) {
        return (
            <Button color={'PRIMARY'} size={'SM'} className="h-10" onClick={addQualification}>
                <div className={'flex gap-1'}>
                    <div className={'my-auto'}>
                        <Plus wh={18} color={"#FFFFFF"} />
                    </div>
                    <div className={'my-auto'}>Créer</div>
                </div>
            </Button>
        );
    }

    return (
        <div className="flex justify-between items-center w-full gap-3 min-w-0">
            <div className="flex gap-2 items-center flex-1 min-w-0">
                <div className="flex-1 min-w-[120px] max-w-[400px]">
                    <StyledInput
                        type="text"
                        placeholder="Rechercher..."
                        imgFront={<SearchLoop wh={16} color="#6B7280" />}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                    />
                </div>
                <div className="flex-shrink-0 max-w-[200px]">
                    <select
                        className="w-full h-10 pl-2 pr-3 ft-b placeholder-gray-600 border rounded-md text-sm focus:border-yellow-500 focus:outline-none"
                        onChange={(e) => setOptionSearch(e.target.value)}
                        value={optionSearch}
                    >
                        {QUALIFICATION_SEARCH_OPTIONS.map((option) => (
                            <option key={option.value} value={option.value}>
                                {option.label}
                            </option>
                        ))}
                    </select>
                </div>
            </div>
            <div className="flex items-center gap-3 flex-shrink-0">
                <Button color={'PRIMARY'} size={'SM'} className="h-10" onClick={addQualification}>
                    <div className={'flex gap-1'}>
                        <div className={'my-auto'}>
                            <Plus wh={18} color={"#FFFFFF"} />
                        </div>
                        <div className={'my-auto'}>Créer</div>
                    </div>
                </Button>
            </div>
        </div>
    );
};

export default HeaderQualification;
